import {_} from './util'
import util from './util'
import moment from 'moment'

function int_day_to_date(int_day){
	let int_day_str = int_day.toString();
    let y = parseInt(int_day_str.substr(0,4),10),
        m = parseInt(int_day_str.substr(4,2),10)-1,
        d = parseInt(int_day_str.substr(6,2),10),
        dt = new Date(y,m,d)
        dt.setHours(0,0,0,0)
    return dt;
}

function broadcast(componentName, eventName, params) {
    this.$children.forEach(child => {
        const name = child.$options.name;

        if (name === componentName) {
            child.$emit.apply(child, [eventName].concat(params));
        } else {
            // todo 如果 params 是空数组，接收到的会是 undefined
            broadcast.apply(child, [componentName, eventName].concat([params]));
        }
    });
}

export default {
    data(){
        return {
            action :'index',
            error:'',
            msg:{
                title:'操作提示',
                description:'操作描述',
                buttons:[],
                icon:'success' //success, warn, info, waiting
            },
            pageIndex: 1,
            pageSize: 10,
            busy: false,
            loading: false,
            isloadAll: false,
            previewShow: false,
            uploadList: [],
            mescroll: null,
            options: {		//图片预览获取压缩图
		        // getThumbBoundsFn (index) {
		        //   // find thumbnail element
		        //   let thumbnail = document.querySelectorAll('.previewer-img')[index]
		          
		        //   // get window scroll Y
		        //   let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
		        //   // optionally get horizontal scroll
		        //   // get position of element relative to viewport
		        //   let rect = thumbnail.getBoundingClientRect()
		        //   // w = width
		        //   return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}
		        // },
                tapToClose:false,
                shareEl:false,
                history:true,
                loop: false,
                // tapToToggleControls: false,
                // zoomEl: false,
                // clickToCloseNonZoomable: false,
                shareButtons: [
                    {id:'download', label:'打开原图', url:'{{raw_image_url}}', download:true}
                ],
                // isClickableElement: function(el) {
                //     return true
                // }
	      	}
        }
    },
	filters:{
		int_date(day_int){
			let s = day_int.toString(),
                t = [],
                l = s.length;
            if (l == 8) {
                t.push(s.substr(0, 4));
                t.push(s.substr(4, 2));
                t.push(s.substr(6, 2));
            } else if (l == 6) {
                for (let i = 0; i < l; i++) {
                    t.push(s.substr(i, 2));
                    i++;
                }
            }
            return t.join('-');
		},
        date_day(day_int) {
            let str = day_int.toString(),
                s = str.substr(str.length - 4),
                t = [],
                l = s.length
            for (let i = 0; i < l; i++) {
                t.push(s.substr(i, 2));
                i++;
            }
            return t.join('-');
        },
		int_week(day_int){
			let t = ['日', '一', '二', '三', '四', '五', '六'];
            let dt = int_day_to_date(day_int);
            return t[dt.getDay()];
		},
		nums_unit(u){
            let map = {0:'个',1:'次',2:'课时',3:'月'}
            return map[u]
        },
		int_hour(hour_int){
			let s = hour_int.toString(),
                t = [],
                l = s.length;
            switch(l){
                case 0:
                    s = '0000';
                    break;
                case 1:
                    s = '000'+s;
                    break;
                case 2:
                    s = '00'+s;
                    break;
                case 3:
                    s = '0'+s;
                    break;
                default:
                    s = s;
            }            
           	t.push(s.substr(0,2))
           	t.push(s.substr(2,2))
            return t.join(':');
		}
	},
    methods: {    	
        focusTextarea(name) {
            console.log(name)
            if(Array.isArray(this.$refs[name])){
                this.$refs[name][0].focus()
            }else{
                this.$refs[name].focus()
            }
        },
    	preview ({list,index}) {
			list = list||[]
			this.list = []
			if(list.length){
				list.forEach(l=>{
					this.list.push({
						src: l.file_url
					})
				})
			}
			this.previewShow = true
			setTimeout(()=>{
				this.$refs.previewer.show(index)					
			},100)
		},
		close () {
			this.previewShow = false
		},
    	imgLoadError (e) {
    		e.target.src = this.defaultImg$
    	},
    	get_students () {
			let user_info = this.$store.state.user.info
			return new Promise((resolve,reject)=>{
				this.$http.get('students?uid='+user_info.uid)
				.then(response=>{					
					let list = response.body.data.list
					this.$store.commit('updateUserInfo',{user: list,action:'updateArchives'})
					resolve(list)
				},response=>{
					reject(response)
				})
			})			
		},
    	getNotice (type){
			let notice = this.$store.state.user.notice,
				field = 'today_'+type+'_num'
			if(notice&&notice[field]){
				return notice[field]
			}
			return 0
		},
		clearNotice (type) {
			this.$store.commit('clearNotice',type)
		},
    	dr(){
            return this.$store.state.layout.$refs['dr']
        },
        page(action){
            this.action = action
        },
        _msg(title,content,icon,first_btn,second_btn){
            this.msg.title = title
            this.msg.description = content
            this.msg.icon = icon
            if(_.isFunction(first_btn)){
                this.msg.buttons[0] = {
                    type:'primary',
                    text:'确定',
                    onClick:first_btn
                }
            }else{
                this.msg.buttons[0] = first_btn
            }
           
            if(second_btn){
                if(_.isFunction(second_btn)){
                    this.msg.buttons[1] = {
                        type:'primary',
                        text:'返回',
                        onClick:second_btn
                    }
                }else{
                    this.msg.buttons[1] = second_btn 
                }
               
            }
            this.page('msg')
        },
        success(title,content,first_btn,second_btn){
            this._msg(title,content,'success',first_btn,second_btn)
        },
        error_msg(title,content,first_btn,second_btn){
            this._msg(title,content,'warn',first_btn,second_btn)
        },
        error_tip(tip){
            this.error = tip
        },
        clear_error(){
            this.error = ''
        },
        dispatch(componentName, eventName, params) {
            let parent = this.$parent || this.$root;
            let name = parent.$options.name;
            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent;

                if (parent) {
                    name = parent.$options.name;
                }
            }
            if (parent) {
                parent.$emit.apply(parent, [eventName].concat(params));
            }
        },
        broadcast(componentName, eventName, params) {
            broadcast.call(this, componentName, eventName, params);
        },
        sapi (method,uri,params,loading) {
        	return new Promise((resolve,reject)=>{
        		if(loading){
        			this.$store.commit('')
        		}
        		this.$http[method](uri,params)
        		.then(response=>{
        			resolve(response)        			
        		}).catch(response=>{        
        			reject(response)
        		})
        	})
        },
        dicts (type) {
        	let gvars = this.$store.state.gvars
        	if(gvars.dicts){
        		let dicts = gvars.dicts[type]
        		if(dicts&&dicts.length>0){
	        		return dicts
	        	}
        	}        	
        	return []
        },
        //获取字典值id:字典id或name，name:字典name
        labelDicts (id,field) {
			let [obj,result] = [this.$store.state.gvars.dicts[field],'']
			if(!_.isEmpty(obj)){
				if(field=='grade'||field=='season'){
					if(result = obj.find(o=>o.name==id)){
						result = obj.find(o=>o.name==id).title						
					}
				}
				
				if(obj.find(o=>o.did===id)){
					result = obj.find(o=>o.did===id).title	
				}					
			}
			return result
		},		
        gvars (type) {
        	let gvars = this.$store.state.gvars
        	return gvars[type]||[]
        },
        downCallback () {
			this.pageIndex = 0
			this.mescroll.resetUpScroll()
		},
		upCallback () {
            let get_param = {} 
        	this.pageIndex++
            get_param.page = this.pageIndex
            get_param.pagesize = this.pageSize
            this.hook_get_param(get_param)
            for(let o in get_param){
                if(get_param[o] === null){
                    delete get_param[o]
                }
            }
            this.$http.get(this.data_uri,{params:get_param})
            .then(response=>{	                
                this.deal_data(response)
                this.upCallbackEnd(response)
            }).catch(response=>{
            	this.mescroll.endErr()
            	this.toast(response.body.message,'text')
            })
        },
        upCallbackEnd (data) {
        	
        },
        hook_get_param (get_param) {
            
        },
        deal_data (response) {
        	let list = response.body.data.list,	
            	total = response.body.data.total,
            	curLength = 0
            	
        	if(this.pageIndex===1){
        		this.data = []
        	}        	
    		this.data = this.data.concat(list)
    		
    		this.mescroll.endBySize(list.length, total)
        },
        loadMore () {
        	if(this.isloadAll){ return false }
            let get_param = {}
        	this.pageIndex++
            get_param.page = this.pageIndex
            get_param.pagesize = this.pageSize
            this.loading = true
            this.busy = true
            this.$http.get(this.data_uri,{params:get_param})
            .then(response=>{
                let list = response.body.data.list
                if(list.length == 0 || list.length < this.pageSize){
                    this.isloadAll = true
                }
                this.data = this.data.concat(list)
            	setTimeout(()=>{
            		this.loading = false
            		this.busy = false	
            	},1000)            	
            }).catch(response=>{
            	this.loading = false
            	this.toast(repsonse.body.message,'text')
            })
        },
        getAge (birth_time) {
        	if(birth_time!=0){
        		return parseInt(moment(new Date()).format('YYYY')) - parseInt(moment(birth_time).format('YYYY')) + '岁'        		
        	}
        	else{
        		return ''
        	}
		},
        toast (msg,type) {
        	//type : success, warn, cancel, text
        	this.$vux.toast.show({
        	  type: type || 'text',
			  text: msg
			})
        },
        alert (title,msg,autoHidden) {
        	return new Promise((resolve,reject)=>{
        		this.$vux.alert.show({
				  title: title || '操作提示',
				  content: msg,
				  onHide() {
				  	resolve()
				  }
				})
		    	if(autoHidden){
		    		setTimeout(()=>{
						this.$vux.alert.hide()
						resolve()
					},3000)
		    	}
        	})	    	
        },
        showLoading () {
	        this.$vux.loading.show({
	          text: 'Loading'
	        })	        
	    },
	    hideLoading () {
	    	setTimeout(() => {
	          this.$vux.loading.hide()
	        }, 300)
	    },
        handleRemove (file) {
            // 从 upload 实例删除数据
            const fileList = this.uploadList;
            this.uploadList.splice(fileList.indexOf(file), 1);
        },
        handleSuccess (res, file) {
        	let data = res.data
        	data.url = data.file_url
            // 上传成功   添加到list
            this.uploadList.push(res.data)
            this.hideLoading()
        },
        handleFormatError (file) {
        	this.hideLoading()
            this.alert(
                '文件格式不正确',
                '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。',
                true
            );            
        },
        handleMaxSize (file) { 
        	this.hideLoading()
            this.alert(
                '超出文件大小限制',
                '文件 ' + file.name + ' 太大，不能超过 2M。',
                true
            );
        },
        handleBeforeUpload (postFiles,file) {
            const check = (postFiles.length + this.uploadList.length) < 10;
            if (!check) {                	
            	this.hideLoading()
                this.alert(
                	'上传错误',
                	'最多只能上传 9  张图片。',
                	true
                );
            }else{
            	this.showLoading()
            }
            return check;
        },
        getUrlKey(name) {
            return (
              decodeURIComponent(
                (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
                  location.href
                ) || [, ''])[1].replace(/\+/g, '%20')
              ) || null
            );
        }
    },
    computed: {
    	isAPP () {
			let u = navigator.userAgent
			if(/(iPhone|iPad|iPod|iOS|Android)/i.test(u)){
				return true
			}else{
				return false
			}
		},
        isIOS () {
            let u = navigator.userAgent
            if(/(iPhone|iPad|iPod|iOS)/i.test(u)){
                return true
            }else{
                return false
            }
        },
    	defaultImg$ () {
    		return 'http://s1.xiao360.com/common_img/avatar.jpg'
    	},
    	showHeader () {
	  		// if(util.isWechat()||this.isAPP){
            //     return false
            // }
            const ua = navigator.userAgent.toLowerCase()
            if(ua.match(/MicroMessenger/i) == "micromessenger" && this.isIOS) {  
                return false
            }
            
            return true
	  	},  
    	headerHeight () {
	  		if(this.showHeader){
	  			return 46
	  		}
	  		return 0
	  	},
    	sid$ () {
    		return this.$store.state.user.info?this.$store.state.user.info.default_sid:0
        },
        level_img() {
			let [standard_level, homework, img] = [
                {
                1: "D",
                2: "C-",
                3: "C",
                4: "C+",
                5: "B-",
                6: "B",
                7: "B+",
                8: "A-",
                9: "A",
                10: "A+"
                },
                this.homework,
                "/assets/images/A.png"
                ];
            let normal_level = { 1: "D", 2: "C", 3: "B", 4: "A" };
                if (homework.is_check === 1) {
                    if (homework.check_level === 2) {
                    img =
                        "/static/img/neza/org/" +
                        normal_level[homework.result_level] +
                        ".png";
                    } else {
                    img =
                        "/static/img/neza/org/" +
                        standard_level[homework.result_level] +
                        ".png";
                    }
                }
                return img;
		},
    	student$ () {
    		let students = this.$store.state.user.info.students,
    			sid = this.sid$,
    			result = {}
    		if(students&&students.length>0&&sid>0){
    			let student = students.find(s=>s.sid==sid)
    			if(student){
    				result = student
    			}
    		}
    		
    		return result
    	},
        hide_student_lesson () {
            let result = 0,
                configs = this.$store.state.gvars.configs
            
            if(configs && configs.params && configs.params.xxgj){
                result = this.$store.state.gvars.configs.params.xxgj.hide_student_lesson
            }
            
            return result
        },
        hide_order_amount() {
            let result = 0,
                configs = this.$store.state.gvars.configs
            
            if(configs && configs.params && configs.params.xxgj){
                result = this.$store.state.gvars.configs.params.xxgj.hide_order_amount
            }
            
            return result
        },
        is_sdb_open() {
            return this.$store.state.user.info.client.func_sdb_open
        },
        enable_lesson_name() {
            return this.$store.state.gvars.configs.params.xxgj.class_show_lesson_name
        },
        enable_qrcode_attendance() {
            return this.$store.state.gvars.configs.params.class_attendance.enable_qrcode_attendance
        },
        course_prepare_visible(){
            return this.$store.state.gvars.configs.params.xxgj.course_prepare_visible == 1
        },
        is_xtjy(){
            let domain = this.$store.state.user.info.client.domain

            return domain == 'xtjy' || domain == 'xintu'
        }
    }
}


// WEBPACK FOOTER //
// ./src/libs/common.mixin.js